import React, { useState } from 'react';
import ForecastReturns from 'components/ForecastReturnsConfig/ForecastReturnsConfig';
import PpBenchmarkToggles from './PpBenchmarkToggles/PpbenchmarkToggles';
import Tab from 'components/Base/Tabs/Tab';
import { Tabs, Typography, makeStyles } from '@material-ui/core';
import UserManagement from './UserManagement/UserManagement';
import Branding from './Branding/Branding';
import ReadOnlyAlert from 'components/Base/Alert/ReadOnlyAlert';
import RiskAnalysis from './RiskAnalysis/RiskAnalysis';
import { Prompt } from 'components/Base';
import Disclaimer from './Disclaimer/Disclaimer';

const useStyles = makeStyles({
  loaderWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    width: '100%',
    position: 'absolute',
    left: 0
  },
  content: {
    margin: '2rem auto',
    width: '100%'
  },
  wrapper: {
    display: 'flex'
  },
  tabWrapper: {
    paddingRight: '1rem',
    borderRight: '1px solid #d4d4d4'
  },
  providerTitle: {
    fontWeight: 700,
    marginBottom: '2rem'
  },
  formWrapper: {
    paddingLeft: '1rem',
    flexGrow: 1
  },
  '@global': {
    '.quill .ql-editor': {
      fontFamily: 'Gilroy, Roboto'
    }
  }
});

const Settings = ({ isFirmAdmin }: any) => {
  const components = [
    {
      title: 'User Management',
      component: UserManagement,
      canView: isFirmAdmin,
      isFirmAdmin: isFirmAdmin
    },
    {
      title: 'Forecast Returns',
      component: ForecastReturns,
      canView: true,
      isFirmAdmin: isFirmAdmin
    },
    {
      title: 'Benchmarks',
      component: PpBenchmarkToggles,
      canView: true,
      isFirmAdmin: isFirmAdmin
    },
    {
      title: 'Risk Profiler',
      component: RiskAnalysis,
      canView: true,
      isFirmAdmin: isFirmAdmin
    },
    {
      title: 'Branding',
      component: Branding,
      canView: true,
      isFirmAdmin: isFirmAdmin
    },
    {
      title: 'Adviser Disclaimer',
      component: Disclaimer,
      canView: true,
      isFirmAdmin: isFirmAdmin
    }
  ] as any;

  const accessibleComponents = components.filter((item: any) => item.canView);
  const classes = useStyles();
  const [tab, setTab] = useState(0);
  const [dirty, setDirty] = useState(false);
  const [isModalVisible, setModalVisible] = useState(false);
  const [targetTab, setTargetTab] = useState<number | null>(null);

  const handleTabChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    if (dirty) {
      setTargetTab(newValue);
      setModalVisible(true);
    } else {
      setTab(newValue);
    }
  };

  const proceedTabChange = () => {
    setDirty(false);
    if (targetTab !== null) {
      setTab(targetTab);
    }
    setModalVisible(false);
  };

  const cancelTabChange = () => {
    setTargetTab(null);
    setModalVisible(false);
  };

  const CurrentComponent = accessibleComponents[tab].component;

  return (
    <div className={classes.content}>
      {!isFirmAdmin && (
        <div style={{ marginBottom: '1rem' }}>
          <ReadOnlyAlert />
        </div>
      )}
      <Typography className={classes.providerTitle} variant="h5" component="h1">
        Firm Settings
      </Typography>
      <div className={classes.wrapper}>
        <div className={classes.tabWrapper}>
          <Tabs
            orientation="vertical"
            style={{ marginBottom: '2rem' }}
            value={tab}
            onChange={handleTabChange}
            TabIndicatorProps={{
              style: { display: 'none' }
            }}
          >
            {accessibleComponents.map((component: any, index: number) => (
              <Tab
                key={index}
                label={component.title}
                id={`simple-tab-${index}`}
                aria-controls={`simple-tabpanel-${index}`}
                style={{ textTransform: 'none' }}
              />
            ))}
          </Tabs>
        </div>

        <div className={classes.formWrapper}>
          <CurrentComponent
            classes={classes}
            isFirmAdmin={isFirmAdmin}
            setDirty={setDirty}
          />
        </div>
      </div>

      <Prompt
        isOpen={isModalVisible}
        title="You have unsaved changes, are you sure you want to leave?"
        confirmAction={proceedTabChange}
        cancelAction={cancelTabChange}
        isProcessing={false}
      />
    </div>
  );
};

export default Settings;
